import { Component, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { SpinnerService } from './spinner.service';

/**
 * Component for spinner
 */
@Component({
  selector: 'app-spinner, [app-spinner]',
  template: ` <div class="esf-spinner" [ngStyle]="{'display': display}" *ngIf="show">
                <div class="row" [ngStyle]="{'display': display}">
                  <span class="esf-spinner__bounce esf-spinner__bounce--1"
                  [ngClass]="{'esf-spinner__bounce--small': autoRefresh, 'fade-out': !tempVal}"
                  ></span>
                  <span class="esf-spinner__bounce esf-spinner__bounce--2"
                  [ngClass]="{'esf-spinner__bounce--small': autoRefresh, 'fade-out': !tempVal}"
                  ></span>
                  <span class="esf-spinner__bounce esf-spinner__bounce--3"
                  [ngClass]="{'esf-spinner__bounce--small': autoRefresh, 'fade-out': !tempVal}"
                  ></span>
                </div>
              </div>`
})
export class SpinnerComponent implements OnInit, OnDestroy {
  public isShowing: boolean = false;
  public tempVal: boolean;
  @Input() public group: string;
  @Input() public name: string;
  @Input() public autoRefresh: boolean = false;
  @Input() public display: string = 'block';
  @Output() public showChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  get show(): boolean {
    return this.isShowing;
  }
  set show(value: boolean) {
    this.tempVal = value;
    if (value || !this.autoRefresh) {
      this.setValue(value);
    } else {
      setTimeout(() => {
        this.setValue(value);
      }, 2000);
    }
  }

  constructor(private spinnerService: SpinnerService) { }

  setValue(val) {
    this.isShowing = val;
    this.showChange.emit(this.isShowing);
  }

  public ngOnInit(): void {
    this.spinnerService._register(this);
  }

  public ngOnDestroy(): void {
    this.spinnerService._unregister(this);
  }
}
